import { NoSymbolIcon } from '@heroicons/react/24/outline';
import * as React from 'react';
import { T } from '../../../Translations';

interface Props {
  disabled: boolean;
}

// Shown above the editor while a communication is off. Editing stays
// available: an admin can keep working on the copy while it is off, and what
// they save takes effect when they turn it back on. Neutral rather than
// alarming -- being off is a state someone chose, not a fault.
const DisabledNotice: React.FC<Props> = ({ disabled }) =>
  disabled ? (
    <div className="flex items-start gap-2 rounded-md border border-border bg-muted px-3 py-2">
      <NoSymbolIcon className="w-4 h-4 shrink-0 text-muted-foreground mt-0.5" />
      <p className="text-foreground" style={{ fontSize: 'var(--text-xs)' }}>
        <T kind="This message is turned off for this collection. Nothing is sent until you turn it back on." />
      </p>
    </div>
  ) : (
    <></>
  );

export default DisabledNotice;
